export const LEAGUE_ROLES = [
  { id: "admin", label: "League Admin" },
  { id: "manager", label: "League Manager" },
  { id: "referee", label: "League Referee" },
  { id: "viewer", label: "League Viewer" },
];

export const LEAGUE_PERMISSION_KEYS = [
  "view_league",
  "manage_season",
  "manage_clubs",
  "manage_fixtures",
  "capture_results",
  "lock_rounds",
  "archive_season",
  "view_executive_insights",
];

const ROLE_PERMISSIONS = {
  admin: Object.fromEntries(LEAGUE_PERMISSION_KEYS.map((key) => [key, true])),
  manager: {
    view_league: true,
    manage_season: true,
    manage_clubs: true,
    manage_fixtures: true,
    capture_results: true,
    lock_rounds: false,
    archive_season: false,
    view_executive_insights: true,
  },
  referee: {
    view_league: true,
    manage_season: false,
    manage_clubs: false,
    manage_fixtures: false,
    capture_results: true,
    lock_rounds: false,
    archive_season: false,
    view_executive_insights: false,
  },
  viewer: {
    view_league: true,
    manage_season: false,
    manage_clubs: false,
    manage_fixtures: false,
    capture_results: false,
    lock_rounds: false,
    archive_season: false,
    view_executive_insights: false,
  },
};

export function normalizeLeagueRole(value) {
  const role = String(value || "").trim().toLowerCase();
  return ROLE_PERMISSIONS[role] ? role : "viewer";
}

export function leaguePermissionsForRole(role) {
  return { ...ROLE_PERMISSIONS[normalizeLeagueRole(role)] };
}

export function resolveLeagueAccess(source = {}) {
  const role = normalizeLeagueRole(source?.leagueRole || source?.leagueAccess?.role || source?.claims?.leagueRole);
  const explicit = source?.leaguePermissions || source?.leagueAccess?.permissions || source?.claims?.leaguePermissions;
  return { role, permissions: { ...leaguePermissionsForRole(role), ...(explicit || {}) } };
}
